import React, { useEffect, useState } from "react";

export default function ZoneTop({ page, region }) {
    
    const [ bgImage, setBgImage ] = useState(null);

    useEffect(() => {
      const _bgImage = page && page[0]?._embedded["wp:featuredmedia"] ? page[0]._embedded["wp:featuredmedia"][0].media_details?.sizes.full?.source_url : '';
    
      _bgImage ? setBgImage(_bgImage) : null;
    }, [page])

    return (
      <div id="zone__top" className={ `${region}` } style={{ backgroundImage: `url(${ bgImage })`}} 
      >
        {
          page?.length > 0 && page[0]?.title && 
              <h1 dangerouslySetInnerHTML= {{ __html: `<span>Bilan 2020</span>${ page[0].title.rendered }` }} />
          }
      
      </div>
    )
      
}

 /*
 // const [ video, setVideo ] = useState(null);
  useEffect(() => {
      let _video = require("../../assets/videos/"+region+".mp4").default;
      _video && setVideo(
          <div id="zone__top" className={ `${region}` } style={{ bgImage ? `backgroundImage: url(${ bgImage })`}}>
            <img className="" src={require('../../assets/img/zone/'+region+'.svg').default } />
            {
              page?.length > 0 && page[0]?.title && 
                  <h1 dangerouslySetInnerHTML= {{ __html: `<span>Bilan 2020</span>${ page[0].title.rendered }` }} />
              }
            
          </div>
        );
  }, [page, region]);
  // '+region+'
*/
      // <img className="" src={require('../../assets/img/zone/est-ensemble.svg').default } />
   // }
    { /* <BackgroundVideo key={region} video={ _video }></BackgroundVideo> */ }